import { VariablesOf } from '@graphql-typed-document-node/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postMessageRN } from 'utils/webview.utils';

import { useEmbedded } from 'hooks/useEmbedded';
import { useAccountsClient } from 'services/api';
import { useTrackSaudiRewardsLinked } from 'services/datalayer/account';
import { LinkSaudiRewardsAccountDocument } from 'types/api/account.types';

import { accountQuery } from './queries';

export const useLinkSaudiRewardsAccount = () => {
  const accountClient = useAccountsClient();
  const queryClient = useQueryClient();
  const { isEmbedded } = useEmbedded();
  const trackSaudiRewardsLinked = useTrackSaudiRewardsLinked();

  const { isPending, isPaused, mutate } = useMutation({
    mutationFn: (
      input: VariablesOf<typeof LinkSaudiRewardsAccountDocument>['input'],
    ) => accountClient.request(LinkSaudiRewardsAccountDocument, { input }),
    onSuccess: ({ linkLoyaltyAccount }) => {
      queryClient.invalidateQueries({ queryKey: accountQuery.queryKey });
      queryClient.setQueryData(accountQuery.queryKey, (oldData) => {
        if (!!oldData) {
          return {
            ...oldData,
            account: {
              ...oldData?.account,
              saudiRewardsMemberId: linkLoyaltyAccount.memberId ?? '',
            },
          };
        }
      });
      if (isEmbedded) {
        postMessageRN({
          type: 'analytics-saudi-rewards-linked',
        });
      } else {
        trackSaudiRewardsLinked({});
      }
    },
  });

  return {
    linkSaudiRewardsAccount: mutate,
    isLoading: isPending && !isPaused,
  };
};
